import { ProductThumb } from './ProductThumb';

export default ProductThumb;
